/*
 *   V 0.9.0 - 2025-02-19
 *       - Added day-trip-navigator
 *       - Added a name tag to routes for use by vue-gtag
 *       - commented out Assets
 *       - Added and remoeved
 *
 *   V 0.8.0 - 2024-12-11
 *       - Added Car Battery routes.
 *
 *   V 0.7.0 -2024-10-08
 *       - Added    '/vehicle-select/:page/:filter/:description/:name/:pass',
 *         which allows a login from Raptor Control to the vehicle select
 *         page/
 *
 *   V 0.6.0 - 2024-09-18
 *        - Added Mole
 *
 *   V 0.5.0 - 2024-07-10
 *       - Added DaySelect for DayTripper
 *
 *   V 0.4.1 - 2024-05-06
 *       - Added MapTripPlotAll.vue to work on plotting all trips for a
 *         day
 *
 *   V 0.4.0 - 2023-04-03
 *       - removed all references to pages in the root - all pages
 *         should now be in v1
 *
 *   V0.3.1  - 2023-03-28
 *       - Moved from CodeSandBox here
 *
 *   V 0.3.0 - 2023-03-22
 *       - Added routes for new VehicleSelect
 *
 *   V 0.2.0 - 2023-02-28
 *       - Added Map All, converted Home to start on
 *
 *   V 0.1.0 - 2022-05-11
 *        - Added  path: "/assets/:name/:pass"  TO be used when we log in from
 *          the control room.
 *
 *
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

import Logout from './pages/v1/Logout'
import VehicleSelect from './pages/v1/VehicleSelect'
import About from './pages/v1/About'
//import MapFollow from './pages/v1/MapFollow'
// import MapAllV2 from './pages/v1/MapAll.v2'
import CalendarTrips from './pages/v1/CalendarTrips'
// import TripPlot from './pages/v1/TripPlot.vue'

//import MapTripPlotAll from './pages/v1/MapTripPlotAll.vue'

// import Assets from './pages/v1/Assets'
import DaySelect from './pages/v1/DaySelect'

import Mole from './pages/v1/Mole'
import MoleSelect from './pages/v1/MoleSelect'
import CarBattery from './pages/v1/CarBattery'

import VehicleTimeLine from './pages/v1/VehicleTimeLine'
import DaySelectTimeline from './pages/v1/DaySelectTimeline'

import DayNavigator from './pages/v2/DayNavigator'
import DayTripNavigator from './pages/v2/DayTripNavigator'

import CalendarObd from './pages/v2/CalendarObd'
import ObdGraph from './pages/v2/ObdGraph'

import ObdDayGraph from './pages/v2/ObdDayGraph'

import store from './plugins/store' // path to vuetify export import store from './store';

Vue.use(VueRouter)

const routes = [
  /// --------------------------------------------------------------------------
  ///                          Example
  /// --------------------------------------------------------------------------
  /// {
  ///     path: '/',
  ///     name: 'index',
  ///     components: { default: Index, header: MainNavbar, footer: MainFooter },
  ///     props: {
  ///         header: { colorOnScroll: 400 },
  ///         footer: { backgroundColor: 'black' }
  ///     }
  /// },
  /// --------------------------------------------------------------------------
  {
    path: '/fleet-dashboard', // :unitId/:selectedDate/*',
    name: 'Fleet_Dashboard_v2',
    component: () => import('@/pages/v2/FleetDashboard.vue'), // Your component
    props: true // This automatically passes route.params as props
  },
  {
    path: '/summary', // :unitId/:selectedDate/*',
    name: 'Fleet_Dashboard',
    component: () => import('@/pages/v2/SummaryReport.vue'), // Your component
    props: true // This automatically passes route.params as props
  },
  {
    path: '/trip-list-speed/:UnitID/:VehicleReg/:dayDate', // :unitId/:selectedDate/*',
    name: 'Trip_List_Speed_Back',
    component: () => import('@/pages/v2/TripListSpeed.vue'), // Your component
    props: true // This automatically passes route.params as props
  },
  {
    path: '/trip-list-speed/:UnitID/:VehicleReg/:Driver/:VehicleID', // :unitId/:selectedDate/*',
    name: 'Trip_List_Speed',
    component: () => import('@/pages/v2/TripListSpeed.vue'), // Your component
    props: true // This automatically passes route.params as props
  },

  {
    path: '/map-follow/:UnitID/:VehicleReg/:Driver/:VehicleID/:Lat/:Lng',
    component: () => import('@/pages/v2/MapFollow.v2.vue'),
    name: 'MapFollow_Vehicle_v2'
  },

  {
    path: '/map-follow/:UnitID/:VehicleReg/:Driver/:VehicleID',
    component: () => import('@/pages/v2/MapFollow.v3.vue'), // Your component
    name: 'MapFollow_Vehicle_v3'
  },

  {
    path: '/trip-list/:UnitID/:VehicleReg/:Driver/:VehicleID', // :unitId/:selectedDate/*',
    name: 'Trip_List_Only',
    component: () => import('@/pages/v2/TripListOnly.vue'), // Your component
    props: true // This automatically passes route.params as props
  },

  {
    path: '/trip-list/:UnitID/:VehicleReg/:dayDate/:TripId', // :unitId/:selectedDate/*',
    name: 'Trip_List_Id',
    component: () => import('@/pages/v2/TripListOnly.vue'), // Your component
    props: true // This automatically passes route.params as props
  },

  {
    path: '/trip-list/:UnitID/:VehicleReg/:dayDate', // :unitId/:selectedDate/*',
    name: 'Trip_List_Only_Back',
    component: () => import('@/pages/v2/TripListOnly.vue'), // Your component
    props: true // This automatically passes route.params as props
  },

  // 2022-09-08
  {
    path: '/trip-plot/:Id/:UnitID/:VehicleReg/:previousPage/:dayDate/:VehicleID',
    component: () => import('@/pages/v2/DayTripNav.v2.vue'), // Your component,
    name: 'DayTripNav_SingleTrip'
  },

  {
    path: '/map-all',
    component: () => import('@/pages/v2/MapAll.v3.vue'), // Your component
    name: 'Map_All_Vehicles_Home_v3'
  },

  {
    path: '/calendar-trips-select/:UnitID/:VehicleReg/:dayDate',
    component: () => import('@/pages/v2/CalendarTrips.v2.vue'), // Your component
    name: 'Calendar_Trips_Select_v2'
    // props: true // This automatically passes route.params as props
  },

  {
    path: '/calendar-trips-select/:UnitID/:VehicleReg/:Driver/:UnitModelId',
    component: () => import('@/pages/v2/CalendarTrips.v2.vue'), // Your component
    name: 'Calendar_Trips_sel_v2'
  },

  /// --------------------------------------------------------------------------
  ///
  /// added: 2025-03-18 to prevent the
  ///
  /// --------------------------------------------------------------------------
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      if (store.state.simpleView) {
        next('/about') // Redirect to the updated path
      } else {
        next('/map-all')
      }
    }
  },

  /// --------------------------------------------------------------------------
  /// added 2025-07-29
  /// --------------------------------------------------------------------------

  // 2022-09-08
  {
    path: '/obd-plot/:Id/:UnitID/:VehicleReg/:previousPage/:dayDate/:VehicleID',
    component: ObdGraph,
    name: 'OBD_Plot_Graph'
  },

  {
    path: '/obd-day-plot/:UnitID/:VehicleReg/:previousPage/:dayDate',
    component: ObdDayGraph,
    name: 'Calendar_Obd_Day_Select'
  },
  {
    path: '/obd-trip-select/:UnitID/:VehicleReg/:Driver/:UnitModelId',
    component: CalendarObd,
    name: 'Calendar_Obd_Select'
  },
  {
    path: '/obd-trip-select/:UnitID/:VehicleReg/:dayDate',
    component: CalendarObd,
    name: 'Calendar_Obd_Select_Back'
  },
  /// --------------------------------------------------------------------------
  ///
  /// added: 2025-02-19
  ///
  /// --------------------------------------------------------------------------
  {
    path: '/day-trip-navigator/:UnitID/:VehicleReg/:previousPage/:dayDate/:VehicleID',
    component: DayTripNavigator,
    name: 'DayTripNavigator'
  },

  {
    path: '/day-navigator/:UnitID/:VehicleReg/:dayDate', // route used by back button on menu
    component: DayNavigator,
    name: 'DayNavigator_BackButton'
  },
  {
    path: '/day-navigator/:UnitID/:VehicleReg/:Driver/:UnitModelId',
    component: DayNavigator,
    name: 'DayNavigator'
  },

  /// --------------------------------------------------------------------------
  /// added: 2024-12-18
  {
    path: '/timeline/:UnitID/:VehicleReg/:previousPage/:dayDate/:VehicleID',
    component: VehicleTimeLine,
    name: 'DaySelectTimeline_VehicleID'
  },

  {
    path: '/day-select-timeline/:UnitID/:VehicleReg/:dayDate',
    component: DaySelectTimeline,
    name: 'DaySelectTimeline_dayDate'
  },
  {
    path: '/day-select-timeline/:UnitID/:VehicleReg/:Driver/:UnitModelId',
    component: DaySelectTimeline,
    name: 'DaySelectTimeline_UnitModelId'
  },

  {
    path: '/timeline/:UnitID/:VehicleReg/:dayDate/:VehicleID',
    component: VehicleTimeLine,
    name: 'VehicleTimeLineUnitID'
  },
  {
    path: '/timeline/:UnitID/:VehicleReg/:TripDate',
    component: VehicleTimeLine,
    name: 'VehicleTimeLineTripDate'
  },

  {
    path: '/timeline/:UnitID/:VehicleReg',
    component: VehicleTimeLine,
    name: 'VehicleTimeLine'
  },

  {
    path: '/car-battery/:UnitID/:VehicleReg/:dayDate/:VehicleID/:UnitModel2ID',
    component: CarBattery,
    name: 'CarBattery_VehicleIdUnitModel2ID'
  },
  {
    path: '/car-battery/:UnitID/:VehicleReg/:dayDate/:VehicleID',
    component: CarBattery,
    name: 'CarBattery_VehicleId'
  },
  {
    path: '/car-battery/:UnitID/:VehicleReg',
    component: CarBattery,
    name: 'CarBattery'
  },

  /// --------------------------------------------------------------------------
  ///  Mole
  /// --------------------------------------------------------------------------
  {
    path: '/mole-select/:UnitID/:VehicleReg/:dayDate/:VehicleID',
    component: Mole,
    name: 'MoleSelectVehicle'
  },
  {
    path: '/day-select/:UnitID/:VehicleReg/:dayDate',
    component: DaySelect,
    name: 'DaySelectVehicle'
  },
  {
    path: '/day-select/:UnitID/:VehicleReg/:Driver/:UnitModelId',
    component: DaySelect,
    name: 'DaySelectMole'
  },

  {
    path: '/unit-select/:page/:filter/:description',
    component: MoleSelect,
    name: 'MoleSelect'
  },

  /// --------------------------------------------------------------------------
  /// --------------------------------------------------------------------------

  {
    path: '/about',
    component: About,
    name: 'About'
  },

  /// --------------------------------------------------------------------------
  ///  2024-09-17
  ///    - added filter
  ///
  ///  2023-03-20
  ///    -
  /// --------------------------------------------------------------------------
  {
    path: '/vehicle-select/:page/:filter/:description/:name/:pass/:all',
    component: VehicleSelect,
    name: 'VehicleSelectWithFilterAll'
  },
  {
    path: '/vehicle-select/:page/:filter/:description/:name/:pass',
    component: VehicleSelect,
    name: 'VehicleSelect_NameAndPassword'
  },
  {
    path: '/vehicle-select/:page/:filter/:description/:VehicleID',
    component: VehicleSelect,
    name: 'VehicleSelect_VehicleID'
  },
  {
    path: '/vehicle-select/:page/:filter/:description',
    component: VehicleSelect,
    name: 'VehicleSelect_description'
  },
  {
    path: '/vehicle-select/:page/:filter',
    component: VehicleSelect,
    name: 'VehicleSelect_filter'
  },
  {
    path: '/vehicle-select/:page',
    component: VehicleSelect,
    name: 'VehicleSelect_page'
  },
  {
    path: '/vehicle-select',
    component: VehicleSelect
  },

  {
    path: '/logout',
    component: Logout,
    name: 'LogoutScreen'
  },

  {
    path: '/Switch/:full_screen',
    beforeEnter () {
      if (this.$screenfull.isEnabled) {
        this.$screenfull.request()
      }
      // called before the route that renders this component is confirmed.
      // does NOT have access to `this` component instance,
      // because it has not been created yet when this guard is called!
    }
  }
]

/*   scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
 */

//
// removed 'history' mode because it interfered with the google markers I was using
// to navigate from a vehicle to its trips on teh follow or all map
//
const router = new VueRouter({
  // mode: 'history', // Use "history" instead of "hash" for routes withouth #
  routes
})

export default router
